import { ComponentProps, useState } from "react";
import { InputCalendar } from "../../../Atoms/Inputs/InputCalendar/inputCalendar";
import { InputCheckbox } from "../../../Atoms/Inputs/InputCheckbox/inputCheckbox";
import { InputText } from "../../../Atoms/Inputs/InputText/inputText";
import * as S from "./styles";
import { SimpleSelect } from "../../../Atoms/SimpleSelect/select";
import { TextArea } from "../../../Atoms/TextArea/textArea";
import { ButtonCustom } from "../../../Atoms/ButtonCustom/buttonCustom";
import { CardWitness } from "../../../Atoms/CardWitness/cardWitness";
import { InputRadio } from "../../../Atoms/Inputs/InputRadio/inputRadio";
import { IDenunciaForm } from "../../../../types/denuncia";
import { useFormComplaint } from "./useFormComplaint";
import dayjs from "dayjs";
import { ISelectOptions } from "../../../../types/inputs";
import { v4 } from "uuid";

interface FormComplaintProps extends ComponentProps<"form"> {
  hanldleSubmit: (data: IDenunciaForm) => void;
}

export const FormComplaint = ({
  hanldleSubmit,
  ...rest
}: FormComplaintProps) => {
  const {
    isAnonymous,
    setAnonymous,
    form,
    updateForm,
    submitForm,
    setTestemunha,
    testemunhas,
    testemunha,
    handleDeleteTestemunha,
    handleAddTestemunha,
    ASSEDIOS_OPTIONS,
    DEMANDAS_OPTIONS,
  } = useFormComplaint();

  return (
    <S.FormComplaintStyle
      {...rest}
      onSubmit={(e) => submitForm({ e, hanldleSubmit })}
    >
      <div>
        <h2>Dados do Colaborador</h2>
      </div>

      <S.FormFieldsAnonymous>
        <div>
          <InputCheckbox
            checked={isAnonymous}
            onChange={(e) => {
              const check = e.target.checked;
              setAnonymous(check);
            }}
            label="Denunciar Anonimamente"
          />
        </div>

        <div>
          <InputText
            disabled={isAnonymous}
            label="Nome"
            value={form.nomeColaborador}
            onChange={(e) => updateForm({ nomeColaborador: e?.target?.value })}
          />
        </div>

        <div>
          <InputCalendar
            disabled={isAnonymous}
            showIcon
            selected={form.dataAdmissao && dayjs(form.dataAdmissao).toDate()}
            onChange={(e) =>
              updateForm({ dataAdmissao: dayjs(e).format("YYYY-MM-DD") })
            }
            label="Data de Admissão"
          />
        </div>

        <div>
          <InputText
            disabled={isAnonymous}
            label="Cargo"
            value={form.cargoColaborador}
            onChange={(e) => updateForm({ cargoColaborador: e?.target?.value })}
          />
        </div>

        <div>
          <InputText
            disabled={isAnonymous}
            label="Setor/Departamento/Empresa"
            value={form.setorColaborador}
            onChange={(e) => updateForm({ setorColaborador: e?.target?.value })}
          />
        </div>
      </S.FormFieldsAnonymous>

      <div>
        <h2>Dados do Acusado</h2>
      </div>

      <S.FormFieldsAccused>
        <div>
          <InputText
            label="Nome"
            required
            value={form.nomeAcusado}
            onChange={(e) => updateForm({ nomeAcusado: e?.target?.value })}
          />
        </div>
        <div>
          <InputText
            label="Cargo"
            required
            value={form.cargoAcusado}
            onChange={(e) => updateForm({ cargoAcusado: e?.target?.value })}
          />
        </div>
        <div>
          <InputText
            label="Setor/Departamento/Empresa"
            value={form.setorAcusado}
            onChange={(e) => updateForm({ setorAcusado: e?.target?.value })}
          />
        </div>
        <div>
          <SimpleSelect
            label="Tipo de Assédio"
            required
            options={ASSEDIOS_OPTIONS}
            value={ASSEDIOS_OPTIONS.find(
              (option) => option.value === form.tipoAssedio
            )}
            onChange={(e: ISelectOptions) =>
              updateForm({ tipoAssedio: e?.value })
            }
          />
        </div>
      </S.FormFieldsAccused>

      <div>
        <h2>Descrição</h2>
      </div>

      <S.FormFieldsDescription>
        <div>
          <InputCalendar
            label="Data"
            showIcon
            selected={
              form.dataOcorrencia && dayjs(form.dataOcorrencia).toDate()
            }
            onChange={(e) =>
              updateForm({ dataOcorrencia: dayjs(e).format("YYYY-MM-DD") })
            }
          />
        </div>

        <div>
          <InputText
            label="Local"
            value={form.localizacao}
            onChange={(e) => updateForm({ localizacao: e?.target?.value })}
          />
        </div>

        <div>
          <TextArea
            required
            label="Descrição do Assédio"
            value={form.descricao}
            onChange={(e) => updateForm({ descricao: e?.target?.value })}
          />
        </div>
      </S.FormFieldsDescription>

      <div>
        <h2>Testemunhas</h2>
      </div>

      <S.FormFieldsWitnesses>
        <div>
          <InputText
            value={testemunha.nome}
            label="Nome"
            onChange={(e) =>
              setTestemunha({ ...testemunha, nome: e?.target?.value })
            }
          />
        </div>
        <div>
          <InputText
            label="Cargo"
            value={testemunha.cargo}
            onChange={(e) =>
              setTestemunha({ ...testemunha, cargo: e?.target?.value })
            }
          />
        </div>

        <div>
          <ButtonCustom type="button" onClick={handleAddTestemunha}>
            Inserir
          </ButtonCustom>
        </div>
      </S.FormFieldsWitnesses>

      <S.WrapperCardsWitness>
        {testemunhas.length > 0 &&
          testemunhas.map((t) => (
            <CardWitness
              key={t.uuid}
              nome={t.nome}
              cargo={t.cargo}
              handleDelete={() => handleDeleteTestemunha(t.uuid)}
            />
          ))}
      </S.WrapperCardsWitness>

      <div>
        <h2>Medidas Tomadas</h2>
      </div>

      <S.Questions>
        <S.WrapperQuestion>
          <p>
            Procurou um superior?<span>*</span>
          </p>

          <div>
            <InputRadio
              required
              label="Sim"
              name="procurar-superior"
              checked={
                typeof form.procurouSuperior === "boolean" &&
                form.procurouSuperior
              }
              onChange={() => updateForm({ procurouSuperior: true })}
            />
          </div>

          <div>
            <InputRadio
              required
              label="Não"
              name="procurar-superior"
              checked={
                typeof form.procurouSuperior === "boolean" &&
                form.procurouSuperior === false
              }
              onChange={() => updateForm({ procurouSuperior: false })}
            />
          </div>

          {typeof form.procurouSuperior === "boolean" &&
            form.procurouSuperior && (
              <div>
                <InputText
                  label="Nome do Superior"
                  required
                  value={form.nomeSuperior}
                  onChange={(e) =>
                    updateForm({ nomeSuperior: e?.target?.value })
                  }
                />
              </div>
            )}
        </S.WrapperQuestion>

        <S.WrapperQuestion>
          <p>
            Informou o RH?<span>*</span>
          </p>

          <div>
            <InputRadio
              required
              label="Sim"
              name="rh"
              checked={form.informouRh}
              onChange={() => updateForm({ informouRh: true })}
            />
          </div>

          <div>
            <InputRadio
              required
              label="Não"
              name="rh"
              checked={typeof form.informouRh === "boolean" && !form.informouRh}
              onChange={() => updateForm({ informouRh: false })}
            />
          </div>
        </S.WrapperQuestion>

        <S.WrapperQuestion>
          <p>
            Registrou Boletim de Ocorrência (B.O.)?<span>*</span>
          </p>

          <div>
            <InputRadio
              required
              label="Sim"
              name="boletim"
              checked={form.registrouBo}
              onChange={() => updateForm({ registrouBo: true })}
            />
          </div>

          <div>
            <InputRadio
              required
              label="Não"
              name="boletim"
              checked={
                typeof form.registrouBo === "boolean" && !form.registrouBo
              }
              onChange={() => updateForm({ registrouBo: false })}
            />
          </div>
        </S.WrapperQuestion>

        <S.WrapperTextArea>
          <TextArea
            label="Outras Ações Tomadas"
            value={form.outrasAcoes}
            onChange={(e) => updateForm({ outrasAcoes: e?.target?.value })}
          />
        </S.WrapperTextArea>
      </S.Questions>

      <div>
        <h2>Solicitação</h2>
      </div>

      <S.FormFieldsRequest>
        <div>
          <SimpleSelect
            required
            label="Demanda"
            options={DEMANDAS_OPTIONS}
            value={
              DEMANDAS_OPTIONS.find((d) => d.value === form.demanda) || null
            }
            onChange={(e: ISelectOptions) => updateForm({ demanda: e?.value })}
          />
        </div>
        <div>
          <TextArea
            label="Outras solicitações"
            value={form.outrasSolicitacoes}
            onChange={(e) =>
              updateForm({ outrasSolicitacoes: e?.target?.value })
            }
          />
        </div>

        <div>
          <ButtonCustom>Avançar</ButtonCustom>
        </div>
      </S.FormFieldsRequest>
    </S.FormComplaintStyle>
  );
};
